import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

export const Duplicate = (props: Props) => (
  <>
    <span className="t-sr-only">Duplicate</span>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3364_19423)">
        <path
          d="M10.5775 1.636L9.4355 0.4565C9.29525 0.312483 9.12765 0.19792 8.94254 0.119531C8.75743 0.0411412 8.55853 0.000503216 8.3575 0L6 0C5.4239 0.000727262 4.86566 0.200045 4.41937 0.564359C3.97309 0.928673 3.66605 1.43571 3.55 2H3.5C2.8372 2.00079 2.20178 2.26444 1.73311 2.73311C1.26444 3.20178 1.00079 3.8372 1 4.5V9.5C1.00079 10.1628 1.26444 10.7982 1.73311 11.2669C2.20178 11.7356 2.8372 11.9992 3.5 12H6.5C7.1628 11.9992 7.79822 11.7356 8.26689 11.2669C8.73556 10.7982 8.99921 10.1628 9 9.5V9.45C9.56429 9.33395 10.0713 9.02691 10.4356 8.58063C10.8 8.13434 10.9993 7.5761 11 7V2.68C11.0008 2.29021 10.8491 1.91556 10.5775 1.636ZM6.5 11H3.5C3.10218 11 2.72064 10.842 2.43934 10.5607C2.15804 10.2794 2 9.89782 2 9.5V4.5C2 4.10218 2.15804 3.72064 2.43934 3.43934C2.72064 3.15804 3.10218 3 3.5 3V7C3.50079 7.6628 3.76444 8.29822 4.23311 8.76689C4.70178 9.23556 5.3372 9.49921 6 9.5H8C8 9.89782 7.84196 10.2794 7.56066 10.5607C7.27936 10.842 6.89782 11 6.5 11ZM8.5 8.5H6C5.60218 8.5 5.22064 8.34196 4.93934 8.06066C4.65804 7.77936 4.5 7.39782 4.5 7V2.5C4.5 2.10218 4.65804 1.72064 4.93934 1.43934C5.22064 1.15804 5.60218 1 6 1H8V2C8 2.26522 8.10536 2.51957 8.29289 2.70711C8.48043 2.89464 8.73478 3 9 3H10V7C10 7.39782 9.84196 7.77936 9.56066 8.06066C9.27936 8.34196 8.89782 8.5 8.5 8.5Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_3364_19423">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
